import api from "@/services/api";


const _http = {

    async getAll() {
        try {
            const response = await api.get("/partner-type");
            return response;
        } catch (error) {
            console.error("Error fetching partner type:", error);
            return [];
        }
    },

    async create(data){
        return api.post("/partner-type", data);
    },

    async update(id,data){
        return api.put(`/partner-type/${id}`, data);
    },

    async updateStatus(id, is_active) {
        return api.put(`/partner-type/${id}/status`, { is_active });
    }
};




export default {
  async getAll(query = {}) {
    try {
      const res = await _http.getAll(query);

      return {
        data: res.data.data.data.map((item) => item),
      };
    } catch (error) {
      console.error(error);

      return {
        data: [],
      };
    }
  },

  async create(payload) {
    try {
      const response = await _http.create(payload);
      return response.data;
    } catch (error) {
      console.error("Error creating partner type:", error);
      throw error;
    }
  },

  async update(id, payload) {
    try {
      const response = await _http.update(id, payload);
      return response.data;
    } catch (error) {
      console.error("Error updating partner type:", error);
      throw error;
    }
  },

  async updateStatus(id, status) {
    try {
      const response = await _http.updateStatus(id, status);
      return response.data;
    } catch (error) {
      console.error("Error updating partner type status:", error);
      throw error;
    }
  },
};

